<template>
  <section class="page-section page---welcome ">
    <div class="container-fluid">
      <div class="row align-items-end justify-content-between">
        <Register
            @registered="registered"
            v-if="!store.id"
            auction="auction"
        >
        </Register>
        <Welcome
            v-if="store.id && !item.id && !finished"
        >
        </Welcome>
        <End
            v-if="store.id && !item.id && finished"
        >
        </End>
        <Item :item="item" v-if="item.id && store.id">
        </Item>
      </div>
    </div>
  </section>
</template>
<script>
import Register from "./visitor/Register";
import Welcome from "./visitor/Welcome";
import Item from "./visitor/Item";
import End from "./visitor/End";

import { visitor } from '../stores/visitor';
// import Echo from "laravel-echo";

export default {
  components: {
    Register,
    Welcome,
    Item,
    End
  },
  setup() {
    const store = visitor()

    return {
      store,
    }
  },
  data() {
    return {
      item: {},
      finished: false,
      auction: false,
    };
  },
  mounted() {
    this.checkIfUserExists();
    this.getActiveAuction();
    // this.getActiveItem();
    // this.listen();
  },
  methods: {
    registered(data) {
      localStorage.storedData = this.input;
    },
    getActiveAuction() {
      let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
      axios({
        method: 'GET',
        url: '/api/auction/active',
        data: {'X-CSRF-TOKEN': csrfToken},
      })
          .then(response => {
            if (
                response.data.status &&
                response.data.status == 'success' &&
                response.data.data) {
                this.auction = response.data.data;
                if (this.store.auction && this.auction != this.store.auction) {
                    axios({
                        method: 'POST',
                        url: '/api/auction/' + this.auction + '/attendee/store',
                        data: {'X-CSRF-TOKEN': csrfToken, 'name': this.store.name},
                    })
                        .then(response => {
                            if (response.data.status && response.data.status == 'success') {
                                this.store.$state['auction'] = response.data.auction;
                            }
                        });
                }
                this.getActiveItem();
                this.listen();
            }
          });
    },
    getActiveItem() {
      if(this.item) {
        let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;

        axios({
          method: 'GET',
          url: '/api/auction/' + this.auction + '/item/active',
          data: {'X-CSRF-TOKEN': csrfToken},
        })
            .then(response => {
              if (
                  response.data.status &&
                  response.data.status == 'success' &&
                  response.data.data) {
                this.item = response.data.data;
                this.auction = this.item.auction_id
              }
            });
      } else {
        this.getActiveAuction();
      }

    },
    checkIfUserExists(){
      let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;

      axios({
        method: 'GET',
        url: '/api/auction/' + this.auction + '/attendee/' + localStorage.getItem("hash") + '/info',
        data: {'X-CSRF-TOKEN': csrfToken},
      })
          .then(response => {
            if(response.data.length < 1){
              if(localStorage.getItem("hash") != null){
                localStorage.clear();
                window.location.href = window.location.protocol + "//" + window.location.hostname;
              }
            }
          });
    },
    listen() {
      const event = Echo.private('auction-channel-' + this.auction)
          .listenForWhisper('start', (e) => {
            this.checkIfUserExists();
          })
          .listenForWhisper('startScreen', () => {
            window.location.reload();
          })

      const test = Echo.channel('auction-channel-' + this.auction)
          .listen('.item.auction.active', (e) => {
            this.item = e.auctionItem;
          })
          .listen('.auction.finished', (e) => {
            this.finished = true;
            this.item = {};
          })

      
    },
  }
}
</script>
